module.exports = __webpack_public_path__ + "img/domestic-1983-marx.2b269307.jpg";